import React from 'react';
import { Spinner } from 'reactstrap';
import './Loader.scss';

type LoaderProps = {
    text?: string;
    size?: string;
    color?: string;
    type?: string;
};

export default function Loader({ text, ...spinnerProps }: LoaderProps) {
    return (
        // The wrapper is the single live region; the Spinner is presentational
        // to avoid nested status regions. When `text` is set, suppress the
        // Spinner's default sr-only "Loading..." child so it isn't announced
        // alongside our specific text.
        <div className="loader" role="status">
            <Spinner color="primary" role="presentation" {...spinnerProps}>
                {text ? '' : undefined}
            </Spinner>
            <h3>{text || ''}</h3>
        </div>
    );
}
